import { render, staticRenderFns } from "./HistoryDetail.vue?vue&type=template&id=0c72177c&lang=pug"
import script from "./HistoryDetail.vue?vue&type=script&lang=js"
export * from "./HistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./HistoryDetail.vue?vue&type=style&index=0&id=0c72177c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports